import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { Public as PublicIcon, Link as LinkIcon } from "@mui/icons-material";
import { useState } from "react";
import Copiable from "components/ui/Copiable";

export default function ShareRunMenuItem({ run, onClick }) {
  const [open, setOpen] = useState(false);
  const onToggle = () => {
    setOpen(!open);
  };

  if (!run.shared) {
    return null;
  }

  return (
    <>
      <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
          onClick();
        }}
      >
        <PublicIcon sx={{ mr: 1 }} fontSize="small" />
        Share Link
      </MenuItem>
      <Dialog open={open} onClose={onToggle} maxWidth="xs" fullWidth>
        <DialogTitle>Share View</DialogTitle>
        <DialogContent sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Typography
            variant="body1"
            sx={{
              maxWidth: "280px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >{`${window.location.origin}/viewer/simulation/${run.hash}`}</Typography>
          <Copiable
            text={`${window.location.origin}/viewer/simulation/${run.hash}`}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              <LinkIcon sx={{ mr: 1 }} color="primary" />
              <Typography variant="text" color="primary" fontSize="12px">
                Copy Link
              </Typography>
            </Box>
          </Copiable>
        </DialogContent>
        <DialogActions>
          <Button onClick={onToggle} sx={{ fontWeight: "bold" }}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
